export enum InputStatus {
  ACTIVE = 'active',
  ERROR = 'error',
  DISABLED = 'disabled',
}

export interface InputProps {
  value: string | undefined;
  label: string | undefined;
  status?: string | undefined;
  setInputBoxStatus?: any;
  onChange: (value: string) => void;
}
